import {GET_ORDER_DATA,GET_ORDER_LISTING,GET_RMA_DETAILS}  from "./../../AppConfig";


const initialState={
    orderData:{},
    // email:"",
    searchString:"",
    orderIdentifier:""
}

export default  function(state=initialState, action){
    switch(action.type){
        case GET_ORDER_DATA:        
            return {
                ...state,
                orderData:action.payload,
                // email:action.email,
                searchString:action.searchString,
                orderIdentifier:action.orderIdentifier,
                returnIdFromOrderListing:action.returnIdFromOrderListing                
            }           
        case GET_RMA_DETAILS:
            return{
                ...state,
                returnRMAItemDetails:action.payload,
            } 
        case GET_ORDER_LISTING:
            return {
                ...state,
                orderListing:action.payload,
                orderIdentifier: action.orderIdentifier 
            }             
            
        default:
        return state;
    }
}

 


// WEBPACK FOOTER //
// ./src/redux/reducers/orderReducer.js